export const IMPORT_PATIENT_REQUEST = 'IMPORT_PATIENT_REQUEST'
export const IMPORT_PATIENT_SUCCESS = 'IMPORT_PATIENT_SUCCESS'
export const IMPORT_PATIENT_FAIL = 'IMPORT_PATIENT_FAIL'

export const LIST_IMPORT_PATIENT_REQUEST = 'LIST_IMPORT_PATIENT_REQUEST'
export const LIST_IMPORT_PATIENT_SUCCESS = 'LIST_IMPORT_PATIENT_SUCCESS'
export const LIST_IMPORT_PATIENT_FAIL = 'LIST_IMPORT_PATIENT_FAIL'

export const LIST_DETAIL_IMPORT_PATIENT_REQUEST = 'LIST_DETAIL_IMPORT_PATIENT_REQUEST'
export const LIST_DETAIL_IMPORT_PATIENT_SUCCESS = 'LIST_DETAIL_IMPORT_PATIENT_SUCCESS'
export const LIST_DETAIL_IMPORT_PATIENT_FAIL = 'LIST_DETAIL_IMPORT_PATIENT_FAIL'

export const DETAIL_IMPORT_PATIENT_REQUEST = 'DETAIL_IMPORT_PATIENT_REQUEST'
export const DETAIL_IMPORT_PATIENT_SUCCESS = 'DETAIL_IMPORT_PATIENT_SUCCESS'
export const DETAIL_IMPORT_PATIENT_FAIL = 'DETAIL_IMPORT_PATIENT_FAIL'

export const EXPORT_IMPORT_PATIENT_REQUEST = 'EXPORT_IMPORT_PATIENT_REQUEST'
export const EXPORT_IMPORT_PATIENT_SUCCESS = 'EXPORT_IMPORT_PATIENT_SUCCESS'
export const EXPORT_IMPORT_PATIENT_FAIL = 'EXPORT_IMPORT_PATIENT_FAIL'

export const EXPORT_ALL_IMPORT_PATIENT_REQUEST = 'EXPORT_ALL_IMPORT_PATIENT_REQUEST'
export const EXPORT_ALL_IMPORT_PATIENT_SUCCESS = 'EXPORT_ALL_IMPORT_PATIENT_SUCCESS'
export const EXPORT_ALL_IMPORT_PATIENT_FAIL = 'EXPORT_ALL_IMPORT_PATIENT_FAIL'

export const CLEAR_IMPORT_PATIENT = 'CLEAR_IMPORT_PATIENT'

export const LIST_EXPORT_PATIENT_REQUEST = 'LIST_EXPORT_PATIENT_REQUEST'
export const LIST_EXPORT_PATIENT_SUCCESS = 'LIST_EXPORT_PATIENT_SUCCESS'
export const LIST_EXPORT_PATIENT_FAIL = 'LIST_EXPORT_PATIENT_FAIL'


export const DOWNLOAD_EXPORT_PATIENT_REQUEST = 'DOWNLOAD_EXPORT_PATIENT_REQUEST'
export const DOWNLOAD_EXPORT_PATIENT_SUCCESS = 'DOWNLOAD_EXPORT_PATIENT_SUCCESS'
export const DOWNLOAD_EXPORT_PATIENT_FAIL = 'DOWNLOAD_EXPORT_PATIENT_FAIL'